<template>
	<v-checkbox class="app-checkbox" v-bind="$attrs" v-on="$listeners" v-model="isOnLocal" :label="label" hide-details></v-checkbox>
</template>

<script>
export default {
	name: 'AppCheckbox',
	props: {
		isOn: { type: Boolean },
		label: { type: String },
	},
	computed: {
		isOnLocal: {
			get() {
				return this.isOn;
			},
			set(value) {
				this.$emit('update:isOn', value);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.app-checkbox {
}
</style>
